import React, { Component } from 'react';
import Cabecalho from '../componentes/Cabecalho';
import Rodape from '../componentes/Rodape';
import { Link } from 'react-router-dom';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import FloatingWhatsApp from '../componentes/WhatsAppFlutuante';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CarrosselMarcas from '../componentes/CarrosselMarcas';
import { formatCambio, formatMoney } from '../utils/formatUtils';
import { fetchRevenda, subscribeToCollection } from '../utils/firestoreUtils';
import { scrollToTop } from '../utils/scrollUtils';
import veiculoUtils from '../utils/infoSubmitVeiculos';

class Estoque extends Component {

    constructor(props) {
        super(props);

        this.state = {
            veiculos: [],
            veiculosComplete: [],
            veiculosInicias: [],
            countVeiculos: 0,
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
            revenda: {},
            marcaSelecionada: null,
        }

        this.mounted = false;
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        scrollToTop();

        this.unsubscribeFunctions = [];

        fetchRevenda(this.setState.bind(this));

        subscribeToCollection(
            "veiculos",
            {
                filters: [
                    ["veremovido", "==", 0],
                    ["vevendido", "==", 0]
                ],
                orderBy: "updated_at",
                stateKey: "veiculos",
                processDoc: (document) => (document["veexibir_site"] !== false ? document : null),
            },
            (state) => {
                this.setState({
                    veiculos: state.veiculos,
                    veiculosComplete: state.veiculos,
                    veiculosInicias: state.veiculos
                });
            },
            this.unsubscribeFunctions
        );
    }

    componentWillUnmount() {
        this.unsubscribeFunctions.forEach(unsubscribe => unsubscribe());
    }

    handleMarcaFilter = (marcaSelecionada) => {
        let filtro = marcaSelecionada.toLowerCase().trim();

        let veiculosFilter = this.state.veiculosComplete.filter((veiculo) => {
            let infoVeiculo = veiculo.vefipe_marca.toLowerCase() + " " + veiculo.vefipe_name.toLowerCase();
            return infoVeiculo.includes(filtro);
        });

        this.setState({ veiculos: veiculosFilter });
    };

    handleMarcaSelecionada = (marca) => {
        this.setState({ marcaSelecionada: marca }, () => {
            this.handleMarcaFilter(marca);
        });
    };

    handleSubmit(event) {
        event.preventDefault();

        const filtro = this.state.buscaVeiculo.toLowerCase().trim();
        const tipoVeiculo = this.state.tipoVeiculo;

        const veiculosFilter = this.state.veiculosInicias.filter(veiculo => {
            const descricaoVeiculo = veiculoUtils.getDescricaoVeiculo(veiculo);

            if (veiculoUtils.isNovo(tipoVeiculo)) {
                return veiculoUtils.isNovoVeiculo(veiculo, descricaoVeiculo, filtro);
            }

            if (veiculoUtils.isSeminovo(tipoVeiculo)) {
                return veiculoUtils.isSeminovoVeiculo(veiculo, descricaoVeiculo, filtro);
            }

            return descricaoVeiculo.includes(filtro);
        });

        this.setState({
            veiculos: veiculosFilter
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleClick() {
        this.setState({
            veiculos: this.state.veiculosComplete,
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
        });
    }

    render() {
        const {
            veiculos,
            tipoVeiculo,
        } = this.state;

        return (
            <div>
                <Cabecalho revenda={this.state.revenda} />

                <section>
                    <div className="container">
                        <div className="row text-center intro-title">
                            <div className="col-md-12 text-md-left d-inline-block">
                                <h1 className="text-black">ESTOQUE</h1>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="carrossel">
                    <h2 style={{ display: 'flex', justifyContent: 'center' }}>Somos uma Loja multimarcas</h2>
                    <CarrosselMarcas onMarcaSelecionada={this.handleMarcaSelecionada} />
                </div>

                <section className="product-listing page-section-ptb" style={{ paddingTop: "0px" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <ValidatorForm id="contactForm" className="s-form wow zoomInUp" ref="form" onSubmit={this.handleSubmit} >
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <TextValidator
                                                placeholder="Ex.: Fiat Palio"
                                                label="Encontre seu carro"
                                                onChange={this.handleChange}
                                                name="buscaVeiculo"
                                                value={this.state.buscaVeiculo}
                                                className="form-ui-bootstrap" />
                                        </div>

                                        <div className="col-lg-3" style={{ paddingTop: "44px" }}>
                                            <SelectValidator
                                                value={tipoVeiculo}
                                                name="tipoVeiculo"
                                                className="form-ui-bootstrap select-busca-veiculos"
                                                onChange={this.handleChange}>
                                                <MenuItem value="todos">Todos</MenuItem>
                                                <MenuItem value="novos">0 Km</MenuItem>
                                                <MenuItem value="seminovos">Seminovos</MenuItem>
                                            </SelectValidator>
                                        </div>

                                        <div className="col-lg-3 text-center" style={{ paddingTop: "30px" }}>
                                            <button type="submit" className="btn m-btn">BUSCAR CARROS<span className="fa fa-angle-right"></span></button><br />
                                            <p className="linkLimparBusca text-center" onClick={this.handleClick}>LIMPAR BUSCA</p>
                                        </div>
                                    </div>
                                </ValidatorForm>

                                <div className="row">
                                    {Object.keys(veiculos).length === 0 ? (
                                        <div className="col-12 text-center">
                                            <p>Nenhum veículo encontrado</p>
                                        </div>
                                    ) : (
                                        Object.keys(veiculos).map(key => {
                                            return (
                                                <div className="col-lg-2" data-wow-delay="0.5s" key={veiculos[key].id}>
                                                    <Link to={"/veiculo/" + veiculos[key].id}>
                                                        <div className="car-item gray-bg text-center">
                                                            <div className="car-image">
                                                                {veiculos[key].imagens.length > 0 ? (
                                                                    veiculos[key].imagens[0].fileThumb !== undefined ? (
                                                                        <img className="img-fluid" src={veiculos[key].imagens[0].fileThumb} alt="" />
                                                                    ) : (
                                                                        <img className="img-fluid" src={veiculos[key].imagens[0].fileUrl} alt="" />
                                                                    )
                                                                ) : (
                                                                    <img className="img-fluid" src="/images/car_default.png" alt="imagem veículo" />
                                                                )}
                                                                <div className="car-overlay-banner"></div>
                                                            </div>
                                                            <div className="car-list">
                                                                <ul className="list-inline">
                                                                    <li>
                                                                        <i className="fa fa-registered"></i>
                                                                        {this.state.veiculos[key].veano_fabricacao}/{this.state.veiculos[key].vefipe_ano_modelo}
                                                                    </li>
                                                                    <li><i className="fa fa-cog"></i>{formatCambio(veiculos[key].vecambio)}</li>
                                                                    <li><i className="fa fa-dashboard"></i>{veiculos[key].vequilometragem} KM</li>
                                                                </ul>
                                                            </div>
                                                            <div className="car-content">
                                                                <span style={{ color: "#1a1a1a" }}>
                                                                    {veiculos[key].veano_fabricacao}/{veiculos[key].vefipe_ano_modelo}
                                                                </span>
                                                                <Link to={"/veiculo/" + veiculos[key].id}>
                                                                    {veiculos[key].vefipe_marca} {veiculos[key].vefipe_name}
                                                                </Link>
                                                                <div className="separator"></div>
                                                                <div className="price">
                                                                    <span className="new-price">
                                                                        <span className="new-price">{formatMoney(veiculos[key].vevalor)}</span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Rodape revenda={this.state.revenda} />
            </div>
        )
    }
}

export default Estoque;